import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "mt-8 space-y-5" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" }
const _hoisted_6 = { class: "overflow-x-auto" }
const _hoisted_7 = { class: "min-w-full" }
const _hoisted_8 = { class: "bg-blue-900" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["colspan"]
const _hoisted_11 = { class: "px-5 py-4 text-sm text-slate-500 whitespace-nowrap" }
const _hoisted_12 = { class: "px-5 py-4 text-sm text-slate-500 whitespace-nowrap" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 1,
  class: "max-h-24 overflow-y-auto break-words whitespace-pre-wrap pr-1"
}
const _hoisted_15 = { class: "flex flex-wrap items-center justify-between gap-3 px-6 py-4 border-t border-slate-100" }
const _hoisted_16 = { class: "text-xs text-slate-500" }
const _hoisted_17 = { class: "font-semibold text-slate-700" }
const _hoisted_18 = { class: "font-semibold text-slate-700" }
const _hoisted_19 = { class: "font-semibold text-slate-700" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = ["max", "value"]
const _hoisted_22 = { class: "text-xs text-slate-500" }
const _hoisted_23 = { class: "flex gap-2" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { GET_ORANGTUA_ASUH } from '@/store/orangtuaAsuh.module'
import Breadcrumb from '@/components/AppBreadcrumb.vue'
import AppSelect from '@/components/input/AppSelect.vue'

const title      = 'Orangtua Asuh'

export default /*@__PURE__*/_defineComponent({
  __name: 'OrangtuaAsuhView',
  setup(__props) {

const store = useStore()

const isLoading  = ref(true)
const page       = ref(1)
const limit      = ref(5)
const search     = ref('')
const sortOrder  = ref('DESC')

const limitOptions = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 100, label: '100' },
]
const sortOptions = [
  { value: 'DESC', label: 'Terbaru' },
  { value: 'ASC', label: 'Terlama' },
]

const rows       = computed(() => store.getters['orangtuaAsuh/orangtuaAsuh'] ?? [])
const pagination = computed(() => store.getters['orangtuaAsuh/orangtuaAsuhPagination'])

const columns = computed<string[]>(() => {
  const keys = new Set<string>()
  for (const row of rows.value) {
    for (const k of Object.keys(row.payload?.answersByLabel ?? {})) {
      keys.add(k)
    }
  }
  return Array.from(keys)
})

let searchDebounce: ReturnType<typeof setTimeout> | null = null
function onSearchInput() {
  if (searchDebounce) clearTimeout(searchDebounce)
  searchDebounce = setTimeout(() => {
    page.value = 1
    getData()
  }, 400)
}

function isUrl(val?: string): boolean {
  return typeof val === 'string' && /^https?:\/\//.test(val)
}

function formatDate(iso?: string): string {
  if (!iso) return '-'
  return new Date(iso).toLocaleDateString('id-ID', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  })
}

function jumpToPage(val: string) {
  const n = parseInt(val, 10)
  const max = pagination.value.totalPages || 1
  if (!isNaN(n)) {
    page.value = Math.max(1, Math.min(n, max))
    getData()
  }
}

const getData = async () => {
  isLoading.value = true
  await store.dispatch(`orangtuaAsuh/${GET_ORANGTUA_ASUH}`, {
    search: search.value || undefined,
    limit: limit.value,
    page: page.value,
    sortOrder: sortOrder.value,
  })
  isLoading.value = false
}

onMounted(getData)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: title }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, _toDisplayString(title)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, "Data pendaftar program Orangtua Asuh.", -1))
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("a", {
            href: "https://docs.google.com/spreadsheets/d/13w3FcIz4jjIBcf7DvG_83FmU8NBss_MkGt4lM7U6x6k/edit?usp=sharing",
            target: "_blank",
            rel: "noopener noreferrer",
            class: "inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-bold text-white shadow-lg transition-all hover:-translate-y-px hover:bg-emerald-400 hover:shadow-xl sm:w-auto"
          }, [
            _createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              })
            ]),
            _createTextVNode(" Spreadsheet ")
          ], -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(AppSelect, {
          modelValue: limit.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((limit).value = $event)),
          options: limitOptions,
          class: "w-24",
          onChange: _cache[1] || (_cache[1] = () => { page.value = 1; getData() })
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("svg", {
            class: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
            })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
            onInput: onSearchInput,
            placeholder: "Cari...",
            class: "pl-9 pr-4 py-2 text-sm text-slate-700 bg-white border border-slate-200 rounded-lg w-52 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400 transition-all placeholder-slate-400"
          }, null, 544), [
            [_vModelText, search.value]
          ])
        ]),
        _createVNode(AppSelect, {
          modelValue: sortOrder.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sortOrder).value = $event)),
          options: sortOptions,
          class: "w-32",
          onChange: _cache[4] || (_cache[4] = () => { page.value = 1; getData() })
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_8, [
                _cache[13] || (_cache[13] = _createElementVNode("th", { class: "px-5 py-3.5 text-left text-sm font-semibold text-blue-100 w-10 whitespace-nowrap" }, "No", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("th", { class: "px-5 py-3.5 text-left text-sm font-semibold text-blue-100 whitespace-nowrap" }, "Tanggal Kirim", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: col,
                    class: "px-5 py-3.5 text-left text-sm font-semibold text-blue-100 whitespace-nowrap"
                  }, _toDisplayString(col), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (isLoading.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(limit.value, (i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: i,
                      class: "border-b border-slate-100"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value.length + 2, (c) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: c,
                          class: "px-5 py-4"
                        }, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("div", { class: "h-4 bg-slate-100 rounded animate-pulse w-full max-w-[140px]" }, null, -1)
                        ]))]))
                      }), 128))
                    ]))
                  }), 128))
                : (!rows.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                      _createElementVNode("td", {
                        colspan: columns.value.length + 2,
                        class: "px-5 py-12 text-center text-sm text-slate-400 italic"
                      }, " Tidak ada data ditemukan. ", 8, _hoisted_10)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(rows.value, (row, idx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.id,
                        class: "border-b border-slate-100 hover:bg-blue-50/40 transition-colors"
                      }, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(pagination.value.start + idx) + ".", 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(formatDate(row.submittedAt)), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: col,
                            class: "px-5 py-4 text-sm text-slate-700 max-w-[260px]"
                          }, [
                            (isUrl(row.payload?.answersByLabel?.[col]))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: row.payload.answersByLabel[col],
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "inline-flex items-center gap-1 text-blue-600 hover:underline break-all"
                                }, [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode(" Lihat ", -1),
                                  _createElementVNode("svg", {
                                    class: "w-3 h-3 flex-shrink-0",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                    })
                                  ], -1)
                                ]))], 8, _hoisted_13))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(row.payload?.answersByLabel?.[col] ?? ''), 1))
                          ]))
                        }), 128))
                      ]))
                    }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, [
            _cache[17] || (_cache[17] = _createTextVNode(" Menampilkan ", -1)),
            _createElementVNode("span", _hoisted_17, _toDisplayString(pagination.value.start), 1),
            _cache[18] || (_cache[18] = _createTextVNode(" - ", -1)),
            _createElementVNode("span", _hoisted_18, _toDisplayString(pagination.value.end), 1),
            _cache[19] || (_cache[19] = _createTextVNode(" dari ", -1)),
            _createElementVNode("span", _hoisted_19, _toDisplayString(pagination.value.totalEntries), 1),
            _cache[20] || (_cache[20] = _createTextVNode(" entri ", -1))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-xs text-slate-500" }, "Halaman", -1)),
            _createElementVNode("input", {
              type: "number",
              min: 1,
              max: pagination.value.totalPages || 1,
              value: page.value,
              onChange: _cache[5] || (_cache[5] = e => jumpToPage((e.target as HTMLInputElement).value)),
              class: "w-14 px-2 py-1.5 text-sm text-slate-700 bg-white border border-slate-200 rounded-lg text-center focus:outline-none focus:ring-2 focus:ring-blue-500/30"
            }, null, 40, _hoisted_21),
            _createElementVNode("span", _hoisted_22, "dari " + _toDisplayString(pagination.value.totalPages || 1), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              class: "px-3.5 py-1.5 text-sm font-medium rounded-lg border border-slate-200 text-slate-600 bg-white hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all",
              disabled: pagination.value.currentPage <= 1,
              onClick: _cache[6] || (_cache[6] = () => { page.value = pagination.value.currentPage - 1; getData() })
            }, " Sebelumnya ", 8, _hoisted_24),
            _createElementVNode("button", {
              class: "px-3.5 py-1.5 text-sm font-medium rounded-lg border border-slate-200 text-slate-600 bg-white hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all",
              disabled: pagination.value.currentPage >= pagination.value.totalPages,
              onClick: _cache[7] || (_cache[7] = () => { page.value = pagination.value.currentPage + 1; getData() })
            }, " Selanjutnya ", 8, _hoisted_25)
          ])
        ])
      ])
    ])
  ]))
}
}

})